import React from 'react';
import { Helmet } from 'react-helmet';
import { renderToStaticMarkup } from 'react-dom/server';

import BrandMark from './BrandMark';
import { isProductionHost, isStagingHost, isStaging } from '../config/environment';

/**
 * Sets the browser-tab favicon to the Poker Ledger brand mark, rendered
 * from <BrandMark/> to an inline SVG data URI.
 *
 * The mark doubles as a three-way environment indicator, so the browser
 * tab makes the environment obvious at a glance:
 *
 * - Production (pokerledger.club) — the standard mark: off-white cards,
 *   brick hearts + diamonds, navy clubs + spades, navy chip.
 * - Staging (next.pokerledger.club) — navy cards, every pip white, red chip.
 * - Local / anything else — navy cards, every pip brick, inverted white chip.
 *
 * Keyed off the live hostname (plus the staging build flag) so it's correct
 * regardless of how the bundle was built — NODE_ENV alone can't tell a local
 * production build from real production.
 */
const Favicon = () => {
    const isStagingEnv = isStagingHost || isStaging;

    let mark;
    if (isProductionHost) {
        mark = <BrandMark size={64} />;
    } else if (isStagingEnv) {
        mark = (
            <BrandMark
                size={64}
                cardFill="#1A2E4A"   // navy card background
                outline="#FBFBFB"    // off-white edges so the fan stays crisp on navy
                heart="#FBFBFB"      // all pips white
                diamond="#FBFBFB"
                club="#FBFBFB"
                spade="#FBFBFB"
                chipPrimary="#C0473C" // red chip…
                chipAccent="#FBFBFB"  // …white rim
            />
        );
    } else {
        mark = (
            <BrandMark
                size={64}
                cardFill="#1A2E4A"   // navy card background
                outline="#FBFBFB"    // off-white edges so the fan stays crisp on navy
                heart="#C0473C"      // all pips brick
                diamond="#C0473C"
                club="#C0473C"
                spade="#C0473C"
                chipPrimary="#FBFBFB" // chip inverts: white primary…
                chipAccent="#1A2E4A"  // …navy accent
            />
        );
    }

    const svgDataUrl = `data:image/svg+xml;base64,${btoa(renderToStaticMarkup(mark))}`;

    return (
        <Helmet>
            <link rel="icon" type="image/svg+xml" href={svgDataUrl} />
        </Helmet>
    );
};

export default Favicon;
